module.exports = __webpack_public_path__ + "static/media/menu10.8722b435.jpg";